import { Controller } from "@hotwired/stimulus"

// Hover / focus tooltip. The content lives in a <template data-tooltip-target="content"> next to
// the trigger; on show it is cloned into a fixed-position card appended to <body>, so it is never
// clipped by an overflow container (tables scroll horizontally inside .table-wrap).
export default class extends Controller {
  static targets = ["content"]
  static values = { placement: { type: String, default: "bottom" } }

  connect() {
    this.onScroll = () => this.hide()
    this.timer = null
  }

  disconnect() { this.hide() }

  show() {
    if (this.tip || !this.hasContentTarget) return
    clearTimeout(this.timer)
    const tip = document.createElement("div")
    tip.className = "tip"
    tip.setAttribute("role", "tooltip")
    tip.appendChild(this.contentTarget.content.cloneNode(true))
    document.body.appendChild(tip)
    this.tip = tip
    this.position()
    window.addEventListener("scroll", this.onScroll, true)
    window.addEventListener("resize", this.onScroll)
  }

  hide() {
    clearTimeout(this.timer)
    if (!this.tip) return
    this.tip.remove()
    this.tip = null
    window.removeEventListener("scroll", this.onScroll, true)
    window.removeEventListener("resize", this.onScroll)
  }

  // Small delay so sweeping the cursor across a row doesn't flash tooltips.
  delayedShow() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.show(), 120)
  }

  position() {
    const r = this.element.getBoundingClientRect()
    const t = this.tip.getBoundingClientRect()
    const gap = 6
    let top = this.placementValue === "top" ? r.top - t.height - gap : r.bottom + gap
    if (top + t.height > window.innerHeight - 8) top = r.top - t.height - gap   // flip above
    if (top < 8) top = r.bottom + gap
    let left = r.left
    if (left + t.width > window.innerWidth - 8) left = window.innerWidth - t.width - 8
    if (left < 8) left = 8
    this.tip.style.top = `${Math.round(top)}px`
    this.tip.style.left = `${Math.round(left)}px`
  }
}
